import React from 'react';
import './style.css';
import EmployeeList from './components/EmployeeList';
export default function App() {
  return (
    <div>
      <EmployeeList />
    </div>
  );
}
